var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62769 17.5V15.25C5.62769 12.963 7.87769 10.75 7.87769 9.25",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6278 17.5V9.25C14.6275 7.85769 14.0743 6.52249 13.0898 5.53798C12.1053 4.55347 10.7701 4.00027 9.37776 4V4C9.37776 1.75 7.62776 1 5.62776 1V4L1.62776 6.858C1.46517 6.97421 1.32745 7.12173 1.22268 7.29191C1.1179 7.46209 1.04819 7.65148 1.01764 7.84898C0.987081 8.04647 0.996298 8.24808 1.04475 8.44196C1.09319 8.63585 1.17989 8.81809 1.29976 8.978L1.97976 9.885C2.1687 10.137 2.43216 10.3231 2.7328 10.417C3.03344 10.5109 3.356 10.5077 3.65476 10.408L7.12776 9.25H9.37776",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3007 21.783C18.0117 21.018 16.8927 18.439 14.6277 17.5H5.62769C3.36269 18.439 2.24369 21.018 1.95469 21.783C1.90368 21.9161 1.87758 22.0575 1.87769 22.2C1.87769 22.5448 2.01465 22.8754 2.25845 23.1192C2.50224 23.363 2.8329 23.5 3.17769 23.5H17.0777C17.2484 23.5 17.4175 23.4664 17.5752 23.401C17.7329 23.3357 17.8762 23.24 17.9969 23.1192C18.1176 22.9985 18.2134 22.8552 18.2787 22.6975C18.3441 22.5398 18.3777 22.3707 18.3777 22.2C18.3778 22.0575 18.3517 21.9161 18.3007 21.783V21.783Z",
    stroke: "#5928E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.db6d737fad1aaf859e206c5d1b372af7.svg";
export { ForwardRef as ReactComponent };